module.exports = __webpack_public_path__ + "img/paydollar.865e6996.png";